var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-quick-action-button',{attrs:{"title":"Lihat Detail","url":_vm.url,"icon":"eye","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }